<template>
  <div>
    <label class="block text-sm font-medium text-gray-700" v-if="showLabel">
      {{ label }} </label>

    <input type="text"
           :placeholder="placeholder"
           autocomplete="off"
           class="mt-1 block w-full pr-10 border-gray-300 text-gray-900 placeholder-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md rounded-md shadow-sm"
           v-model="input"
           @blur="breakToTags"
           :disabled="disabled"
           />

    <slot name="selected-items" v-if="! single">
      <div class="mt-4 flex gap-2 flex-wrap">
        <Badge v-for="item in tags"
               :key="item.tag"
               class="">
        {{ item.tag }} <XIcon class="ml-1 w-3 h-3 cursor-pointer text-gray-400 hover:text-gray-700" @click="removeTag(item.tag)" v-if="! disabled" />
        </Badge>
      </div>
    </slot>
  </div>
</template>

<script>
import { toRaw } from 'vue'
import Badge from '@/components/badge'
import { XIcon } from '@heroicons/vue/solid'

export default {
  components: {
    Badge,
    XIcon,
  },

  props: {
    selected: {
      type: [Array, String],
      default: () => ([]),
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      required: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    'change',
    'remove',
  ],

  data() {
    return {
      input: '',
      tags: this.selected.map(tag => ({
        tag,
        dirty: false,
      })),
    }
  },

  methods: {
    removeTag(tag) {
      if (this.disabled) {
        return;
      }

      this.tags = this.tags.filter(item => item.tag !== tag)
      this.$emit('change', this.tags.map(item => item.tag))
      this.$emit('remove', tag)
    },

    breakToTags({ clear = true, dirty = false } = {}) {
      const newTags = this.input.split(/\s*,\s*/)
        .map(tag => tag.trim())
        .filter(Boolean)
        .map(tag => ({
          tag,
          dirty,
        }));

      const existingTags = toRaw(this.tags).filter(item => ! item.dirty)
      const uniqueTags = [...newTags, ...existingTags]
        .reduce((carry, item) => ({
          ...carry,
          [item.tag]: item,
        }), {})

      this.tags = Object.values(uniqueTags)

      if (clear) {
        this.input = ''
      }

      this.$emit('change', this.tags.map(item => item.tag))
    },
  },

  watch: {
    input() {
      this.breakToTags({
        dirty: true,
        clear: false,
      });
    },
  },
}
</script>
